<template>
  <transition name="modal">
    <modal
      v-if="isExpiredModalShow"
      class="rates-vacancies-modal rates-vacancies-modal--expired"
      :redesign="true"
      @close="toggleExpiredModal(false)"
    >
      <div slot="header">
        {{
          !isVacanciesRequestSuccess
            ? $tr('vacancy.expired.title')
            : $tr('vacancy.expired.successTitle')
        }}
      </div>

      <div slot="body" class="basic-form modal-height-limited">
        <p>
          {{
            !isVacanciesRequestSuccess
              ? $tr('vacancy.expired.descr')
              : $tr('vacancy.expired.successText')
          }}
        </p>
        <div v-if="!isVacanciesRequestSuccess" class="vacancy-expired-flex">
          <span>{{ $tr('vacancy.expired.more1') }}</span>
          <input
            v-model="vacancyMoreCount"
            class="vacancy-input-expired"
            placeholder="5"
            type="number"
          />
          <span>{{ $tr('vacancy.expired.more2') }}</span>
        </div>
      </div>

      <div v-if="!isVacanciesRequestSuccess" slot="footer">
        <vbutton
          class="creating-cancel"
          label="common.cancel"
          color="grey"
          @click="toggleExpiredModal(false)"
        />
        <vbutton
          :loading="expiredLoading"
          :disabled="!vacancyMoreCount || Number(vacancyMoreCount) < 1 || expiredLoading"
          label="vacancy.expired.submit"
          @click="sendExpiredRequest"
        />
      </div>
    </modal>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Axios from 'axios';
import Modal from '@/components/Modal.vue';

export default {
  components: {
    Modal
  },

  data() {
    return {
      vacancyMoreCount: null,
      isVacanciesRequestSuccess: false,
      expiredLoading: false
    };
  },

  computed: {
    ...mapState('vacancies', ['isExpiredModalShow'])
  },

  methods: {
    ...mapMutations('vacancies', ['SET_IS_EXPIRED_MODAL_SHOW']),

    toggleExpiredModal(val) {
      this.SET_IS_EXPIRED_MODAL_SHOW(val);

      if (!val) {
        this.vacancyMoreCount = null;
        this.isVacanciesRequestSuccess = false;
      }
    },

    sendExpiredRequest() {
      this.expiredLoading = true;

      Axios.post('/1.0/company-limits/tariff/request', {
        vacancy_count: this.vacancyMoreCount
      })
        .then(() => {
          this.isVacanciesRequestSuccess = true;

          setTimeout(() => {
            if (this.isExpiredModalShow) {
              this.toggleExpiredModal(false);
            }
          }, 3000);
        })
        .finally(() => {
          this.expiredLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.rates-vacancies-modal--expired {
  ::v-deep {
    .modal-mask.redesign .modal-container {
      padding: 28px;
      min-width: auto;
    }
    .modal-header {
      // font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      color: #233346;
    }

    .modal-body {
      margin-top: 16px;
      margin-bottom: 32px;

      .basic-form {
        // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        color: #233346;
      }

      p {
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }

      .vacancy-expired-flex {
        display: flex;
        align-items: center;
      }

      .vacancy-input-expired {
        width: 42px;
        // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        text-align: center;
        margin-left: 4px;
        margin-right: 4px;

        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        &::placeholder {
          color: #9faab6;
        }
      }
    }

    .modal-footer {
      justify-content: flex-end;

      .vbutton {
        margin-left: 8px;
      }
    }
  }
}
</style>
